export default __webpack_public_path__ + "static/media/ishan.0340892c.png";